interface IDownload2 {
  width?: number;
  height?: number;
  stroke?: string;
}
export const Download2 = ({ width, height, stroke }: IDownload2) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.5 12.5C2.5 14.857 2.5 16.0355 3.23223 16.7678C3.96447 17.5 5.14298 17.5 7.5 17.5H12.5C14.857 17.5 16.0355 17.5 16.7678 16.7678C17.5 16.0355 17.5 14.857 17.5 12.5'
      stroke={stroke || '#1552E8'}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.99984 2.4987V13.332M9.99984 13.332L13.3332 9.6862M9.99984 13.332L6.6665 9.6862'
      stroke={stroke || '#1552E8'}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
